import { render, staticRenderFns } from "./file-type-name-limit-list.vue?vue&type=template&id=b39c7040"
import script from "./file-type-name-limit-list.vue?vue&type=script&lang=js"
export * from "./file-type-name-limit-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports